import { z } from "zod";
import { dmaSettingParameterDtoSchema } from "../dma-setting-parameter/dma-setting-parameter.schema";
export const dmaSettingDtoSchema = z.object({
    name: z.string(),
    parameters: z.array(dmaSettingParameterDtoSchema),
});
